(function () {
  // LuxCanva: grupeaza vizual add-onurile sub tabloul lor in cos (pagina + drawer).
  if (window.__lcCartGroup) return;
  window.__lcCartGroup = true;

  var ADDON_IDS = [58010305855752, 58010306019592, 58010306183432];
  var running = false;
  var observer = null;

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function isAddon(item) { return item && ADDON_IDS.indexOf(item.variant_id) !== -1; }

  function group(cart) {
    var byKey = {};
    cart.items.forEach(function (i) { byKey[i.key] = i; });

    // grupeaza liniile din DOM pe container-parinte
    var lines = Array.prototype.slice.call(document.querySelectorAll('.cart__item[data-key]'));
    var containers = [];
    lines.forEach(function (el) {
      var it = byKey[el.getAttribute('data-key')];
      if (!it) return;
      var c = el.parentElement;
      if (containers.indexOf(c) === -1) containers.push(c);
      // marcheaza add-on vizual
      if (isAddon(it)) el.classList.add('lc-addon-line'); else el.classList.remove('lc-addon-line');
    });

    var changed = false;
    containers.forEach(function (container) {
      var kids = Array.prototype.slice.call(container.querySelectorAll(':scope > .cart__item[data-key]'));
      if (kids.length < 2) return;
      // ordinea dorita: fiecare parinte urmat de add-onurile lui
      var parents = kids.filter(function (el) { var it = byKey[el.getAttribute('data-key')]; return it && !isAddon(it); });
      var addons = kids.filter(function (el) { var it = byKey[el.getAttribute('data-key')]; return it && isAddon(it); });
      var used = {};
      var desired = [];
      parents.forEach(function (pel) {
        desired.push(pel);
        var pit = byKey[pel.getAttribute('data-key')];
        addons.forEach(function (ael) {
          if (used[ael.getAttribute('data-key')]) return;
          var ait = byKey[ael.getAttribute('data-key')];
          var pr = ait.properties || {};
          // legatura add-on -> tablou: "_tpo_add_by" = variant id-ul tabloului (LC Add-ons v6);
          // fallback "_lc_parent" = product id (varianta noua / pagini native)
          var byVariant = pr._tpo_add_by && String(pr._tpo_add_by) === String(pit.variant_id);
          var byProduct = pr._lc_parent && String(pr._lc_parent) === String(pit.product_id);
          if (byVariant || byProduct) {
            desired.push(ael); used[ael.getAttribute('data-key')] = 1;
          }
        });
      });
      // add-onuri orfane (fara parinte in cos) -> la final
      addons.forEach(function (ael) { if (!used[ael.getAttribute('data-key')]) desired.push(ael); });

      // aplica ordinea daca difera
      var same = kids.length === desired.length && kids.every(function (el, i) { return el === desired[i]; });
      if (!same) {
        // reper = nodul de dupa blocul de linii (ex. subtotalul); inseram toate liniile in ordine inaintea lui
        var ref = kids[kids.length - 1].nextSibling;
        desired.forEach(function (el) { container.insertBefore(el, ref); });
        changed = true;
      }
    });
    return changed;
  }

  var t = null;
  function run() {
    if (running) return;
    running = true;
    fetchCart().then(function (cart) {
      if (observer) observer.disconnect();
      try { group(cart); } catch (e) { /* no-op */ }
      if (observer) observer.observe(document.body, { childList: true, subtree: true });
      running = false;
    }).catch(function () { running = false; });
  }

  function schedule() { clearTimeout(t); t = setTimeout(run, 180); }

  document.addEventListener('DOMContentLoaded', schedule);
  ['cart:refresh', 'cart:updated', 'cart:build', 'ajaxProduct:added', 'theme:cart:open'].forEach(function (ev) {
    document.addEventListener(ev, schedule);
  });

  // reaplica cand tema re-randeaza cosul (drawer/pagina)
  observer = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var m = muts[i];
      for (var j = 0; j < m.addedNodes.length; j++) {
        var n = m.addedNodes[j];
        if (n.nodeType === 1 && (n.matches && n.matches('.cart__item[data-key]') || (n.querySelector && n.querySelector('.cart__item[data-key]')))) {
          schedule(); return;
        }
      }
    }
  });
  observer.observe(document.body, { childList: true, subtree: true });

  schedule();
})();
